module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-linear-5452cca38bf019666c9cb78e9e907e3e.png";